// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"6216605e","453":"4eb94c4f","796":"316fc880"}[chunkId] + ".chunk.js";
};